module.exports = __webpack_public_path__ + "static/media/blue_normal_EN.afe7eb20.png";